<template>
	<div>
		<div style="background-color: #FFFFFF;" class="arrow-img"></div>
		<div class="box">
			<img src="../../../static/move-success.png" alt="">
			<span class="tips">数据迁移成功</span>
			<span class="button" @click="goRoute">去阅读</span>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			goRoute() {
				 this.$base.setStorage('tabbarIndex', 1)
				 this.$router.push({
					 path:'/'
				 })
			}
		}
	}
</script>

<style scoped>
	.arrow-img {
		width: 30px;
		height: 44px;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 999;
	}

	.box {
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	image {
		width: 100px;
		height: 100px;
	}

	.tips {
		display: block;
		font-size: 16px;
		color: #333333;
		font-weight: bold;
		margin-top: 20px;
	}

	.button {
		color: #ffffff;
		text-align: center;
		background-color: #DE3B34;
		font-size: 16px;
		line-height: 33px;
		display: block;
		border-radius: 5px;
		margin: 20px auto;
		margin-top: 100px;
		width: 200px;
	}
</style>



// WEBPACK FOOTER //
// src/view/moveSuccess/index.vue